module.exports = __webpack_public_path__ + "img/photo-19.ee08b812.png";